import { RoutesPaths } from "../../constants/routes"

const SHARED_FILE_PATH = new RegExp(`^${RoutesPaths.sharedFile}/[^/]+/?$`)

/** Whether the address is a document share link's public page. */
export const isSharedFilePath = (pathname: string) =>
  SHARED_FILE_PATH.test(pathname)
